"use client";
import { AppDispatch, RootState } from "@/redux/store";
import config from "./config";
import ehjzleeInstance from "./ehjzleeInstance";
import { useDispatch, useSelector } from "react-redux";
import { clearUser, setUser } from "@/redux/slices/user.slice";
import { useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { logout } from "@/redux/slices/login.slice";

const getUser = async () => {
  const res = await ehjzleeInstance.get(config.user);
  return res.data.user;
};

const useGetUser = (enabled: boolean = true) => {
  const { authReady, isLoggedIn, accessToken } = useSelector(
    (state: RootState) => state.login
  );
  const { data, isLoading, error, ...rest } = useQuery<UserState>({
    queryKey: ["user"],
    queryFn: getUser,
    retry: (failureCount, err) =>
      (err as AxiosError)?.response?.status !== 401 && failureCount < 2,
    enabled: enabled && authReady && isLoggedIn && Boolean(accessToken),
  });

  const dispatch: AppDispatch = useDispatch();

  const userData = useMemo(() => data, [data]);

  useEffect(() => {
    if (!isLoading) {
      if (userData) {
        dispatch(setUser(userData));
      }
    }
  }, [userData, dispatch, isLoading]);

  useEffect(() => {
    if ((error as AxiosError)?.response?.status === 401) {
      dispatch(clearUser());
      dispatch(logout());
    }
  }, [dispatch, error]);

  return { data: userData, error, ...rest };
};

export default useGetUser;
